import EstimateItem from "./estimate-item";
import Decimal from "decimal.js";

/**
 * 見積もり項目の集合
 */
export default class EstimateItems {
  private items: EstimateItem[] = [];

  public constructor(...items: EstimateItem[]) {
    this.items = items;
  }

  public get totalPrice(): Decimal {
    return this.items
      .map(i => i.price)
      .reduce((s, p) => s.plus(p), new Decimal(0));
  }

  public get totalLoss(): Decimal {
    return this.items
      .map(i => i.loss)
      .reduce((s, p) => s.plus(p), new Decimal(0));
  }

  public totalDiscount(categoryDiscountIds: string[]): number {
    return this.items
      .map(i => i.discount(categoryDiscountIds))
      .reduce((s, p) => s + p, 0);
  }

  public isEmpty(): boolean {
    return this.items.length === 0;
  }

  public toJSON(): any[] {
    return this.items.map(i => i.toJSON());
  }
}
